import { helpers } from '@balm-ui';

export const isPhone = (phone) => /^1[0-9]\d{9}$/.test(phone);
export const isEmail = (email) =>
  /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(email);
export const isUrl = (url) =>
  /^(http(s)?:\/\/)?(ftp(s)?:\/\/)?([\w-]+\.)+[\w-]+(:\d{2,5})?(\/?\#?[\w-.\/?#%&=]*)?$/.test(
    url
  );
export const isBV = (id) => /^BV[0-9A-Za-z]{10}/.test(id);
export const isValidPassword = (password) =>
  /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\S])[\dA-Za-z\S]{8,20}$/.test(password); // 特殊字符非必选
export const passwordMessage =
  '必须包含数字、大写字母、小写字母、符号，8-20位，不能有空格';

export default {
  required: {
    validate(value) {
      return !helpers.isEmpty(value);
    },
    message: '%s不能为空'
  },
  requiredWithZero: {
    validate(value) {
      return value === 0 || value === '0' || !helpers.isEmpty(value);
    },
    message: '%s不能为空'
  },
  phone: {
    validate: (value) => (value ? isPhone(value) : true),
    message: '无效的%s'
  },
  email: {
    validate: (value) => isEmail(value),
    message: '无效的%s'
  },
  url: {
    validate: (url) => (url ? isUrl(url) : true),
    message: '无效的%s'
  },
  positiveInteger: {
    validate: (value) => value > 0 && value.toString().indexOf('.') < 0,
    message: '%s只能接受正整数'
  },
  bv: {
    validate: (id) =>
      Array.isArray(id)
        ? id.every((itemId) => (itemId ? isBV(itemId) : true))
        : id
        ? isBV(id)
        : true,
    message: '%s格式不对，请重新核对。'
  },
  password: {
    validate: (value) => isValidPassword(value),
    message: `%s${passwordMessage}`
  }
};
